import { toastManager, ToastStatus } from '../components/ui/toast';

export type ActionToastStatus = Exclude<ToastStatus, 'loading'>;

export interface ActionToastInput {
  status: ActionToastStatus;
  title: string;
  description?: string;
  id?: string;
  duration?: number;
  isClosable?: boolean;
  position?: string;
  variant?: string;
}

let toastSequence = 0;

const durations: Record<ActionToastStatus, number> = {
  success: 3500,
  info: 4500,
  warning: 6000,
  error: 8000,
};

const safeDescription = (description?: string) => {
  if (!description) return undefined;
  return description.replace(/https?:\/\/\S+|Bearer\s+\S+|token[=:]\s*\S+/gi, '').slice(0, 240);
};

export function useActionToast() {
  return ({ status, title, description, id, duration }: ActionToastInput) => {
    toastSequence += 1;
    const toastId = id || `${status}-${title}-${Date.now()}-${toastSequence}`;

    toastManager.add({
      id: toastId,
      title,
      description: safeDescription(description),
      type: status,
      timeout: duration ?? durations[status],
    });
  };
}

export function useFormValidationToast() {
  const actionToast = useActionToast();
  return () => {
    actionToast({
      status: 'error',
      title: 'Revise o formulário',
      description: 'Corrija os campos indicados antes de enviar.',
      id: 'form-validation-error',
    });
  };
}
